import axios from '@/utils/axios'
import jsBridge from '@/utils/jsBridge'
import bbjdApi from './bbjd'
import businessCard from './businessCard'

let api = {
    ...bbjdApi,
    ...businessCard,
    information:{},
    agreement:{},
    answer:{},
    driving:{},
    vow:{},
    share:{},
    timeAuth:{},
    timePay:{},
    lottery:{},
    coachLogin:{},
    appLocation:{},
    exam:{},
    examTraining:{},
    coachSg:{},
    coachContract: {},
    coachContractGzh: {},
    shortVideoShare: {}
};
/**
 * @name 答题技巧
 * @param res
 */

api.answer.detail = function (res) {
    return axios({
        method: 'GET',
        url: '/exam/outer/answerSkill/v1/getById.pass',
        params:res,
    })
};
/**
 * @name 驾驶技巧
 * @param res
 */

api.driving.detail = function (res) {
    return axios({
        method: 'GET',
        url: '/exam/outer/driverSkill/v1/getById.pass',
        params:res,
    })
};
/**
 * @name 资讯详情
 * @param res
 */
api.information.detail = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/advInformationManager/v1/appDetail.pass',
        params:res,
    })
};

/**
 * @name 注册协议
 * @param res
 */

api.agreement.register = function (res) {
    let appType = ''
    if(!jsBridge.hasNativeMethod('getAppType') && !!(navigator.userAgent).match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
        // 定义headers
        appType = 2
    }
    if(res.appType){
        appType = res.appType
    }
    return axios({
        headers:{
            'app-type': appType
        },
        method: 'GET',
        url: '/system/outer/user/agreement.pass',
        params:res,
    })
};
/**
 * @name 报名资料
 * @param res
 */

api.registerData = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/dmEnrollDataList/v1/detail',
        params:res,
    })
};
/**
 * @name 学车意向情景资料
 * @param res
 */

api.getCondition = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/intention/getCondition.pass',
        params:res,
    })
};
/**
 * @name 考场须知
 * @param res
 */
api.dmExamPlaceNoticeDetail = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/dmExamPlaceNotice/v1/detail.pass',
        params:res,
    })
};
/**
 * @name 提交学车意向
 * @param res
 */

api.intentionSave = function (res) {
    return axios({
        method: 'POST',
        url: '/cms/outer/intention/write',
        data:res,
    })
};
/**
 * @name 入学欢迎
 * @param res
 */

api.welcomeSchool = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/dmWelcomeSchool/v1/detail',
        params:res,
    })
};
/**
 * @name 体检流程
 * @param res
 */

api.physicalExamination = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/dmPhysicalExaminationProc/v1/detail',
        params:res,
    })
};

/**
 * @name 许愿池-首页
 * @param res
 */

api.vow.home = function (res) {
    return axios({
        method: 'GET',
        url: '/wish/outer/wisWish/v1/getDetailByWishId?wish',
        params:res,
    })
};

/**
 * @name 许愿池-中奖用户
 * @param res
 */

api.vow.userInfo = function (res) {
    return axios({
        method: 'GET',
        url: '/wish/outer/wisWish/v1/getUserAvatars',
        params:res,
    })
};

/**
 * @name 许愿池-我的许愿
 * @param res
 */

api.vow.myWish = function (res) {
    return axios({
        method: 'GET',
        url: '/wish/outer/wisWish/v1/myWish',
        params:res,
    })
};

/**
 * @name 许愿池-用户手动收获心愿
 * @param res
 */

api.vow.receive = function (res) {
    return axios({
        method: 'GET',
        url: '/wish/outer/wisWish/v1/receive',
        params:res,
    })
};


/**
 * @name 许愿池-设置
 * @param res
 */

api.vow.setting = function (res) {
    return axios({
        method: 'GET',
        url: '/cms/outer/cmsUnitAmountSetting/v1/wish/get',
        params:res,
    })
};

/**
 * @name 许愿池-规则
 * @param res
 */

api.vow.rules = function (res) {
    return axios({
        method: 'GET',
        url: '/wish/outer/wisWish/v1/description/get',
        params:res,
    })
};

/**
 * @name 许愿池-检查支付额度
 * @param res
 */

api.vow.checkUserPointEnough = function (res) {
    return axios({
        method: 'GET',
        url: '/point/outer/pointUserRelation/v1/checkUserPointEnough',
        params:res,
    })
};

/**
 * @name 许愿池-许下心愿
 * @param res
 */

api.vow.wish = function (res) {
    return axios({
        method: 'POST',
        url: '/wish/outer/wisWish/v1/wish',
        data:res,
    })
};

/**
 * @name 活动-详情
 * @param res
 */
api.classInformationdetail = function (res) {
    return axios({
        method: 'GET',
        url: '/activity/outer/actActivity/v1/appDetail.pass',
        params:res,
    })
};
//报名接口-旧
api.classInformationOrder = function (res) {
    return axios({
        method: 'GET',
        url: '/activity/outer/actActivity/v1/order',
        params:res,
    })
};
//报名接口-新
api.classInformationSign = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actActivity/v1/order.pass',
        data:res,
    })
};

//发送短信验证码-新
api.classInformationMsg = function (res) {
    return axios({
        method: 'POST',
        url: '/auth/outer/sysAuth/v1/login/send/message.pass',
        data:res,
    })
};

/**
 * 报名接口-分享人数
 * @param res
 * @returns {*}
 */
api.updateShareCount = function (res) {
    return axios({
        method: 'GET',
        url: '/activity/outer/actActivity/v1/updateShareCount.pass',
        params:res,
    })
};

/**
 * @name 常见问题-详情
 * @param res
 */
api.problemDetail = function (res) {
    return axios({
        headers:{
            'app-type': res.appType
        },
        method: 'GET',
        url: '/cms/outer/faqInfo/v1/detailById.pass',
        params:res,
    })
};
/**
 * @name  -驾校
 * @params
 */
api.getPlatformSchools = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/getPlatformSchools`,
        method: 'GET',
        params: params,
    })
};

/**
 * 计时认证-个人详情
 * @params
 */
api.timeAuth.getVerifiedStudentInfoByUserId = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/getCurrentUserVerifiedStudentInfo`,
        method: 'GET',
        params: params,
    })
};
/**
 * 计时认证-学员认证
 * @params
 */
api.timeAuth.verifyStudent = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/verifyStudent`,
        method: 'POST',
        data: params,
    })
};
/**
 * 计时认证-学员认证支付
 * @params
 */
api.timeAuth.verifyStudentForAppPay = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/verifyStudentForAppPay`,
        method: 'POST',
        data: params,
    })
};
/**
 * 计时认证-学时规则配置-学员端
 * @params
 */
api.timeAuth.getTimingConfig = function (params) {
    return axios({
        url: `/course/outer/parameter/getTimingConfig.pass`,
        method: 'GET',
        params:params,
    })
};
/**
 * 计时认证-学时规则配置-学员端
 * @params
 */
api.timeAuth.getPlatformCitys = function (params) {
    let url = '/user/outer/classhour/v1/getPlatformCitys'
    if(params && params.appKey){
        url = `/user/outer/classhour/v1/getPlatformCitys?appKey=${params.appKey}`
    }
    return axios({
        url: url,
        method: 'POST',
        data:params,
    })
};

/**
 * 获取用户信息
 * @params
 */
api.timeAuth.getUserInfo = function () {
    return axios({
        url: `/user/outer/sysUser/v1/load`,
        method: 'GET'
    })
};

/**
 * 获取最新下载地址
 * @params
 */
api.getLatestCustomAndroidUrl = function () {
    return axios({
        url: `/system/outer/versionManager/v1/getLatestCustomAndroidUrl.pass`,
        method: 'GET'
    })
};

/**
 * 获取短信
 * @params
 */
api.timePay.getMessage = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/wxpublic/message.pass`,
        method: 'POST',
        data:params,
    })
};

/**
 * 获取图形验证码
 * @params
 */
api.timePay.getImageCode = function (params) {
    return axios({
        url: `/auth/outer/sysAuth/v1/imageCode.pass`,
        method: 'GET',
        params:params
    })
};

/**
 * 验证短信
 * @params
 */
api.timePay.checkMessage = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/wxpublic/verifyShortMessageCode.pass`,
        method: 'POST',
        data:params
    })
};


/**
 * 学时认证
 * @params
 */
api.timePay.verifyStudentFromWx = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/verifyStudentFromWx`,
        method: 'POST',
        data:params
    })
};

/**
 * 学时认证
 * @params
 */
api.timePay.checkAndVerifyStudentFromPublicWx = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/checkAndVerifyStudentFromPublicWx`,
        method: 'POST',
        data:params
    })
};

/**
 * 退出登录
 * @params
 */
api.timePay.logoutPublicWx = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/wxpublic/logoutPublicWx`,
        method: 'POST',
        data:params
    })
};

/**
 * 获取分享config
 * @params
 */
api.timePay.getJsapiConfig = function (params) {
    return axios({
        url: `/mall/outer/share/getJsapiConfig.pass`,
        method: 'POST',
        data:params
    })
};

/**
 * 学时保存订单
 * @params
 */
api.timePay.timeSaveOrder = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/v1/saveOrder`,
        method: 'POST',
        data:params
    })
};

/**
 * 学时保存订单安全培训
 * @params
 */
api.timePay.createSafetyTrainOrder = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/createSafetyTrainOrder`,
        method: 'POST',
        data:params
    })
};

/**
 * 根据openid获取订单保存后的信息
 * @params
 */
api.timePay.getVerifiedStudent = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/v1/getVerifiedStudent`,
        method: 'GET',
        params:params
    })
};

/**
 * 获取下单信息
 * @params
 */
api.timePay.checkAndRenewVerifiedStudent = function (params) {
    return axios({
        url: `/user/outer/classhour/v1/checkAndRenewVerifiedStudent`,
        method: 'POST',
        data:params
    })
};

/**
 * 获取用户信息
 * @params
 */
api.timePay.getUserByWeXinPublic = function (params) {
    return axios({
        url: `/auth/outer/sysAuth/v1/weixin/getUserByWeXinPublic.pass`,
        method: 'GET',
        params:params,
    })
};

/**
 * 根据openid获取订单保存后的信息
 * @params
 */
api.timePay.getListOrderByUser = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/v1/listOrderByUser`,
        method: 'POST',
        data:params
    })
};

/**
 * 根据openid获取订单保存后的信息
 * @params
 */
api.timePay.getListOrderByUserForFoshan = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/v1/listOrderByUserForFoshan`,
        method: 'POST',
        data:params
    })
};

/**
 * 根据openid获取订单保存后的信息辽宁
 * @params
 */
api.timePay.listOrderByUserLiaoNing = function (params) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/v1/listOrderByUserLiaoNing`,
        method: 'POST',
        data:params
    })
};

/**
 * 获取学车类型
 * @params
 */
api.getListForSelector = function (params) {
    return axios({
        url: `/user/outer/carCategory/v1/listForSelector`,
        method: 'POST',
        data:params
    })
};
/**
 * 获取分享设置
 * @params
 */
api.getAdSetting = function (params) {
    return axios({
        url: `/cms/outer/shareSetting/getByCode.pass`,
        method: 'GET',
        params:params
    })
};


/**
 * 获取考场视频详情
 * @params
 */
api.share.getExamPlaceVideoDetail = function (params) {
    return axios({
        url: `/exam/outer/examPlaceVideo/detail.pass`,
        method: 'POST',
        params:params
    })
};

/**
 * 获取教学视频详情
 * @params
 */
api.share.getTeachVideoDetail = function (params) {
    return axios({
        url: `/exam/outer/video/v1/play.pass`,
        method: 'GET',
        params:params
    })
};
/**
 * 获取学车报告
 * @params
 */
api.share.getStudyReport = function (params) {
    return axios({
        url: `/cms/outer/learningReportShare/v1/getContent.pass`,
        method: 'GET',
        params:params
    })
};
/**
 * 获取学车报告答题PK
 * @params
 */
api.share.getPKReport = function (params) {
    return axios({
        url: `/battle/outer/batRoom/getScoreReport.pass`,
        method: 'GET',
        params:params
    })
};


/**
 * 获取分享内容
 * @params
 */
api.share.getContent = function (params) {
    return axios({
        url: `/cms/outer/learningReportShare/v1/getContent.pass`,
        method: 'GET',
        params:params
    })
};

/**
 * @name 广告增加次数
 * @param res
 */
api.share.setVisitAd = function (res) {
    return axios({
        url: `/cms/outer/shareStatistics/visitAd/add.pass`,
        method: 'POST',
        data: res
    })
}

/**
 * @name 增加访问次数
 * @param res
 */
api.share.setVisit =  function (res) {
    return axios({
        url: `/cms/outer/shareStatistics/visit/add.pass`,
        method: 'POST',
        data: res
    })
}

/**
 * @name 广告管理-页面广告
 * @param res
 */
api.information.appGetPageList =  function (res) {
    return axios({
        url: `/cms/outer/advAdvertManager/v1/appGetPageList.pass`,
        method: 'POST',
        data: res
    })
}

/**
 * @name 资讯管理-斑讯详情-推荐资讯列表
 * @param res
 */
api.information.getRecommendInfo =  function (res) {
    return axios({
        url: `/cms/outer/advInformationManager/v1/getRecommendInfo.pass`,
        method: 'GET',
        params: res
    })
}

/**
 * @name 广告添加点击量
 * @param res
 */
 api.information.adAddClicks = function (res) {
    return axios({
        method: 'post',
        url: '/cms/outer/advAdvertManager/v1/addClicks.pass',
        data: res,
    })
};

/**
 * @name 大转盘
 * @param res
 */

api.lottery.index = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/index.pass?id='+res.id,
        data:res,
    })
};
/**
 * @name 抽奖
 * @param res
 */

api.lottery.getAward = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/getAward.pass?id='+res.id,
        data:res,
    })
};
/**
 * @name 中奖纪录
 * @param res
 */

api.lottery.myaward = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/myaward.pass?id='+res.id,
        data:res,
    })
};
/**
 * @name 点赞
 * @param res
 */

api.lottery.dianzan = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/dianzan.pass?id='+res.id + '&defuserid=' + res.defuserid,
        data:res,
    })
};
/**
 * @name 获取分享地址
 * @param res
 */
api.lottery.getShareUrl = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/getShareUrl.pass?id='+res.id,
        data:res,
    })
};

/**
 * @name 获取点赞好友
 * @param res
 */
api.lottery.getDzfriend = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/getDzfriend.pass?id='+res.id + '&defuserid=' + res.defuserid,
        data:res,
    })
};
/**
 * @name 集赞分享页面
 * @param res
 */
api.lottery.shareindex = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/shareindex.pass?id='+res.id + '&defuserid=' + res.defuserid,
        data:res,
    })
};
/**
 * @name 最近中奖人员
 * @param res
 */
api.lottery.latestaward = function (res) {
    return axios({
        method: 'POST',
        url: '/activity/outer/actJizan/latestaward.pass?id='+res.id,
        data:res,
    })
};

/**
 * @name 更新照片
 * @param res
 */
api.timeAuth.updatePhoto = function (res) {
    return axios({
        method: 'GET',
        url: '/user/outer/classhour/updatePhoto',
        params:res,
    })
};

/**
 * @name 更新信息
 * @param res
 */
api.timeAuth.updateStunum = function (res) {
    return axios({
        method: 'GET',
        url: '/user/outer/classhour/v1/updateStunum',
        params:res,
    })
};

/**
 * @name 获取车型
 * @param res
 */
api.timeAuth.listForSelector = function (res) {
    return axios({
        method: 'POST',
        url: '/user/outer/carCategory/v1/listForSelector',
        params:res,
    })
};

/**
 * @name 获取学车流程
 * @param res
 */
api.getStudentInfo = function (res) {
    return axios({
        method: 'GET',
        url: '/zjerp/outer/student/v1/getStudentInfo',
        params:res,
    })
};

/**
 * @name 获取接送地点列表
 * @param res
 */
api.appLocation.getPickUpAddress = function (res) {
    return axios({
        method: 'POST',
        url: '/cms/outer/pickUpAddress/v1/getPickUpAddress',
        data:res,
    })
};

/**
 * @name 选择接送地点
 * @param res
 */
api.appLocation.savePickUpAddress = function (res) {
    return axios({
        method: 'POST',
        url: '/cms/outer/pickUpAddress/v1/savePickUpAddress',
        data:res,
    })
};

/**
 * @name 教练登录
 * @param res
 */
api.coachLogin.scanCodeLogin = function (res) {
    return axios({
        method: 'POST',
        url: '/user/outer/scan/v1/scanCodeLogin',
        data:res,
    })
};

/**
 * @name 上海学时
 * @param res
 */
api.shTime = function (res) {
    return axios({
        method: 'POST',
        url: '/classhour/sh/outer/sh/saveBosInfo',
        data:res,
    })
};

/**
 * @name 题库合集查询详情
 * @param res
 */
api.exerciseBookDetail = function (res) {
    return axios({
        method: 'get',
        url: '/exam/outer/exercisebook/getExeciseBookDetail.pass',
        params:res,
    })
};

/**
 * @name 学时列表
 * @param res
 */
api.studentTimeList = function (res) {
    return axios({
        method: 'post',
        url: '/course/inner/courseUserStagetraining/list',
        data:res,
    })
};

/**
 * @name 学时上报列表
 * @param res
 */
api.studentTimeUploadList = function (res) {
    return axios({
        method: 'get',
        url: '/course/inner/courseUserStagetraining/listHistory',
        params:res,
    })
};

/**
 * @name 学时城市列表
 * @param res
 */
api.selectCityBySchoolIds = function (res) {
    return axios({
        method: 'post',
        url: '/course/inner/count/selectCityBySchoolIds',
        data:res,
    })
};

/**
 * @name 获取用户驾校
 * @param res
 */
api.getUserSchools = function (res) {
    return axios({
        method: 'get',
        url: '/zjerp/inner/school/v1/getUserSchools',
        params:res,
    })
};

/**
 * @name 上报学时记录
 * @param res
 */
api.uploadStudentTime = function (res) {
    return axios({
        method: 'post',
        url: '/course/inner/courseUserStagetraining/upload',
        data:res,
    })
};

/**
 * @name 获取微信计时视频详情
 * @param res
 */
api.wxTimeVideoAddRecord = function (res) {
    return axios({
        method: 'post',
        url: '/course/outer/courseInfo/addRecord.pass',
        data:res,
    })
};

// ——————————————————————————————————————————————————————————————

/**
 * @name 百度人脸验证
 * @param res
 */
api.exam.bdfaceVerify = function (res) {
    return axios({
        method: 'post',
        url: '/user/outer/faceid/v3/bdfaceVerify',
        data:res,
    })
};

/**
 * @name 交卷
 * @param res
 */
api.exam.examSubmit = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/examSubmit',
        data:res,
    })
};

/**
 * @name 随机验证
 * @param res
 */
api.exam.randomVerify = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/randomVerify',
        data:res,
    })
};
/**
 * @name 签退验证
 * @param res
 */
api.exam.signout = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/signout',
        data:res,
    })
};

/**
 * @name 开始考试
 * @param res
 */
api.exam.startExam = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/startExam',
        data:res,
    })
};
/**
 * @name 获取题库版本号
 * @param res
 */
api.exam.getVersion = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTiming/getVersion.pass',
        params:res,
    })
};

/**
 * @name 异常退出唤醒
 * @param res
 */
api.exam.weakup = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTiming/weakup',
        params:res,
    })
};

/**
 * @name 更新照片
 * @param res
 */
api.exam.updatePhoto = function (res) {
    return axios({
        method: 'get',
        url: '/user/outer/classhour/updatePhoto',
        params:res,
    })
};
/**
 * @name 获取上传token
 * @param res
 */
api.exam.upToken = function (res) {
    return axios({
        method: 'get',
        url: '/system/outer/attachment/v1/upToken.pass?bucketName=chetailian-public',
        params:res,
    })
};

/**
 * @name 获取计时考试规则
 * @param res
 */
api.exam.getTimingConfig = function (res) {
    return axios({
        method: 'get',
        url: '/courseContinuingEdu/outer/parameter/getTimingConfig.pass',
        params:res,
    })
};
/**
 * @name 获取成绩列表
 * @param res
 */
api.exam.getExaminationList = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/examinationList',
        data:res,
    })
};

/**
 * @name 获取证书
 * @param res
 */
api.exam.getCert = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTiming/getCert',
        params:res,
    })
};
/**
 * @name 同步题库
 * @param res
 */
api.exam.getExerciseSync = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/getExerciseSync.pass',
        data:res,
    })
};
/**
 * @name 进入考试规则页面
 * @param res
 */
api.exam.getExamRule = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTiming/getExamRule',
        params:res,
    })
};
/**
 * @name 模拟考试优先未考
 * @param res
 */
api.exam.firstNotExam = function (res) {
    return axios({
        method: 'get',
        url: '/exam/outer/exam/firstNotExam',
        params:res,
    })
};
/**
 * @name 模拟考试
 * @param res
 */
api.exam.mockExam = function (res) {
    return axios({
        method: 'get',
        url: '/exam/outer/exam/mockExam',
        params:res,
    })
};
/**
 * @name 提交考试
 * @param res
 */
api.exam.submitExam = function (res) {
    return axios({
        method: 'post',
        url: '/exam/outer/exam/submit',
        data:res,
    })
};
/**
 * @name 提交考试答案
 * @param res
 */
api.exam.submitExamAnswer = function (res) {
    return axios({
        method: 'post',
        url: '/exam/outer/exam/examSubmit',
        data:res,
    })
};

// ——————————————————————————————————————————————————————————————
/**
 * @name 百度人脸验证
 * @param res
 */
api.examTraining.bdfaceVerify = function (res) {
    return axios({
        method: 'post',
        url: '/user/outer/faceid/v3/bdfaceVerify',
        data:res,
    })
};
/**
 * @name 交卷
 * @param res
 */
api.examTraining.examSubmit = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTrainingPreJob/examSubmit',
        data:res,
    })
};

/**
 * @name 随机验证
 * @param res
 */
api.examTraining.randomVerify = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTrainingPreJob/randomVerify',
        data:res,
    })
};
/**
 * @name 签退验证
 * @param res
 */
api.examTraining.signout = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTrainingPreJob/signout',
        data:res,
    })
};

/**
 * @name 开始考试
 * @param res
 */
api.examTraining.startExam = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTrainingPreJob/startExam',
        data:res,
    })
};
/**
 * @name 获取题库版本号
 * @param res
 */
api.examTraining.getVersion = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTiming/getVersion.pass',
        params:res,
    })
};

/**
 * @name 异常退出唤醒
 * @param res
 */
api.examTraining.weakup = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTrainingPreJob/weakup',
        params:res,
    })
};

/**
 * @name 更新照片
 * @param res
 */
api.examTraining.updatePhoto = function (res) {
    return axios({
        method: 'get',
        url: '/user/outer/classhour/updatePhoto',
        params:res,
    })
};
/**
 * @name 获取上传token
 * @param res
 */
api.examTraining.upToken = function (res) {
    return axios({
        method: 'get',
        url: '/system/outer/attachment/v1/upToken.pass?bucketName=chetailian-public',
        params:res,
    })
};

/**
 * @name 获取计时考试规则
 * @param res
 */
api.examTraining.getTimingConfig = function (res) {
    return axios({
        method: 'get',
        url: '/courseContinuingEdu/outer/parameter/getTimingConfig.pass',
        params:res,
    })
};
/**
 * @name 获取成绩列表
 * @param res
 */
api.examTraining.getExaminationList = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTrainingPreJob/examinationList',
        data:res,
    })
};

/**
 * @name 获取证书
 * @param res
 */
api.examTraining.getCert = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTrainingPreJob/getCert',
        params:res,
    })
};
/**
 * @name 同步题库
 * @param res
 */
api.examTraining.getExerciseSync = function (res) {
    return axios({
        method: 'post',
        url: '/cartexam/outer/exam/coachTiming/getExerciseSync.pass',
        data:res,
    })
};
/**
 * @name 进入考试规则页面
 * @param res
 */
api.examTraining.getExamRule = function (res) {
    return axios({
        method: 'get',
        url: '/cartexam/outer/exam/coachTrainingPreJob/getExamRule',
        params:res,
    })
};

/**
 * 获取从当天开始至教练可查看排班天数的连续日期
 * @param res
 * @return {*}
 */
api.coachSg.getSerialDates = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/planClassCar/v1/getSerialDates',
        params:res,
    })
};

/**
 * 获取车牌信息
 * @param res
 * @return {*}
 */
api.coachSg.getCarPlatesById = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/carInfoStatistics/v1/getCarPlatesById',
        params:res,
    })
};

/**
 * 获取排班
 * @param res
 * @return {*}
 */
api.coachSg.getPlanClassCarList = function (res) {
    return axios({
        method: 'post',
        url: '/coachsg/outer/planClassCar/v1/getPlanClassCarList',
        data:res,
    })
};

/**
 * 获取申请关闭排班原因类别
 * @param res
 * @return {*}
 */
api.coachSg.getClosePlanClassReasonList = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/closePlanClassVerify/v1/getClosePlanClassReasonList',
        params:res,
    })
};

/**
 * 通过关闭排班记录ID,获取关闭排班明细
 * @param res
 * @return {*}
 */
api.coachSg.getClosePlanClassRecordDetailListById = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/closePlanClassRecord/v1/getClosePlanClassRecordDetailListById',
        params:res,
    })
};

/**
 * 获取教学日志评价项
 * @param res
 * @return {*}
 */
api.coachSg.getAppointmentTeachLogItemList = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/appointmentTeachLogItem/v1/getAppointmentTeachLogItemList',
        params:res,
    })
};

/**
 * 根据教练ID获取预约学员的姓名和头像(未填写教学日志的学员)
 * @param res
 * @return {*}
 */
api.coachSg.getNoFinishTeachLogStuListByCoachId = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/appointmentCarRecord/v1/getNoFinishTeachLogStuListByCoachId',
        params:res,
    })
};

/**
 * 获取接送地址列表
 * @param res
 * @return {*}
 */
api.coachSg.getPickUpRouteList = function (res) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/pickUpRoute/v1/getPickUpRouteList',
        params:res,
    })
};

/**
 * 获取申请关闭排班列表
 * @param res
 * @return {*}
 */
api.coachSg.getClosePlanClassRecordList = function (res) {
    return axios({
        method: 'post',
        url: '/coachsg/outer/closePlanClassRecord/v1/getClosePlanClassRecordList',
        data:res,
    })
};

/**
 * 获取排班计划
 * @param res
 * @return {*}
 */
api.coachSg.getPlanClassCarHoursList = function (res) {
    return axios({
        method: 'post',
        url: '/coachsg/outer/planClassCar/v1/getPlanClassCarHoursList',
        data:res,
    })
};

/**
 * 获取教学日志列表
 * @param res
 * @return {*}
 */
api.coachSg.getAppointmentTeachLogList = function (res) {
    return axios({
        method: 'post',
        url: '/coachsg/outer/appointmentTeachLog/v1/getAppointmentTeachLogList',
        data:res,
    })
};

/**
 * 新增关闭排班
 * @param res
 * @return {*}
 */
api.coachSg.addClosePlanClass = function (res) {
    return axios({
        method: 'post',
        url: '/zjerp/outer/coachClient/closePlanCar/v1/addClosePlanClass',
        data:res,
    })
};

/**
 * 关闭排班审核
 * @param res
 * @return {*}
 */
api.coachSg.verifyClosePlanForCoach = function (res) {
    return axios({
        method: 'post',
        url: '/zjerp/outer/coachClient/closePlanCar/v1/verifyClosePlanForCoach',
        data:res,
    })
};

/**
 * 新增教学日志
 * @param res
 * @return {*}
 */
 api.coachSg.addAppointmentTeachLog = function (res) {
    return axios({
        method: 'post',
        url: '/zjerp/outer/coachClient/closePlanCar/v1/addAppointmentTeachLog',
        data:res,
    })
};

/**
 * 获取满分教育考试规则
 */
api.exam.getExamRuleFullScore = function () {
    return axios({
        method: 'get',
        url: '/exam/outer/exam/suppleCert/getExamRuleFullScore'
    })
};

/**
 * 获取学法减分考试规则
 */
api.exam.getExamRuleLearnMethod = function () {
    return axios({
        method: 'get',
        url: '/exam/outer/exam/suppleCert/getExamRuleLearnMethod'
    })
};

/**
 * 获取三力测试考试规则
 */
api.exam.getExamThreeRules = function () {
    return axios({
        method: 'get',
        url: '/cartexam/outer/examThreeForces/examThreeRules'
    })
};

// —————————————————————————————————————————————————————————————— 教练端电子合同接口
// http://cmobile.dev.chetailian.net

/**
 * 获取车型
 */
 api.coachContract.getCarType = function () {
    return axios({
        method: 'get',
        url: '/coachsg/v1/getCarTypeList'
    })
}

/**
 * 根据车型获取班别
 * @param {String} params.driveType 车型ID
 */
api.coachContract.getClassByCarType = function (params) {
    return axios({
        method: 'get',
        url: '/coachsg/v1/getClassList',
        params
    })
}

/**
 * 根据片区获取pos机
 * @param {String} params.areaId 片区ID
 */
api.coachContract.getPosByAreaId = function (params) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/finPos/v1/getPosByAreaId',
        params
    })
}

/**
 * 获取收款账号列表
 */
api.coachContract.getReceiptAccountsList = function (params) {
    return axios({
        method: 'get',
        url: '/coachsg/outer/finReceiptAccount/v1/getReceiptAccountsList',
        params
    })
}

/**
 * 获取订单列表
 * @param {Object} data
 * @param {Number} data.size 页码
 * @param {Number} data.current 当前页
 * @param {String} data.empId 员工ID
 */
api.coachContract.getPreentryOrderList = function (data) {
    return axios({
        method: 'post',
        url: '/coachsg/v1/getPreentryOrderList',
        data
    })
}

/**
 * 获取订单详情
 * @param {Object} params
 * @param {String} params.orderId 订单ID
 */
api.coachContract.getPreentryOrderDetail = function (params) {
    return axios({
        method: 'get',
        url: '/coachsg/v1/getPreentryOrderDetail',
        params
    })
}

/**
 * 预录订单新增信息(教练端
 * @param {Object} data
 * @param {Object} data.orderInfo
 * @param {Object} data.recordInfo
 */
api.coachContract.saveOrder = function (data) {
    return axios({
        method: 'post',
        url: '/zjerp/outer/coachClient/preEntryOrder/v1/savePreEntryOrderForCoachClient',
        data
    })
}

/**
 * 预录订单新增信息(教练端-其他驾校
 * @param {Object} data
 */
 api.coachContract.saveOtherOrder = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/addStuOrderInfoByCoachApp',
        data
    })
}

/**
 * 预录订单编辑信息信息(教练端-其他驾校
 * @param {Object} data
 */
 api.coachContract.updateOtherOrder = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/updateStuOrderInfoByCoachApp',
        data
    })
}

/**
 * 获取订单列表-其他驾校
 * @param {Object} data
 * @param {Number} data.size 页码
 * @param {Number} data.current 当前页
 * @param {String} data.empId 员工ID
 */
 api.coachContract.getStuOrderListByCoachApp = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/getStuOrderListByCoachApp',
        data
    })
}

/**
 * 获取订单详情-其他驾校
 * @param {Object} params
 * @param {String} params.id 订单ID
 */
api.coachContract.getStuOrderDetailByCoachApp = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/getStuOrderDetailByCoachApp',
        data
    })
}
/**
 * 预录订单新增信息( ocr 扫描接口
 * @param {Object} data
 * @param {Object} data.emblemImg 身份证国徽面图片
 * @param {Object} data.infoImg 身份证信息面图片
 */
api.coachContract.ocrImage = function (data) {
    return axios({
        method: 'post',
        url: '/contract/sign/outer/coachClient/v1/getIdCardByOcr',
        data
    })
}

/**
 * 获取电子合同 学车订单合同地址
 */
 api.coachContract.getOrderContractUrl = function (data) {
    return axios({
        url: `/contract/sign/outer/coachClient/v1/getContractUrlByOrderId`,
        method: 'post',
        data:data
    })
};

/**
 * 根据文件id 获取合同地址
 */
api.coachContract.getContractUrlByFileId = function (params) {
    return axios({
        url: `/contract/sign/outer/coachClient/v1/getContractUrlByFileId`,
        method: 'get',
        params:params
    })
};

/**
 * 获取附加条款
 */
api.coachContract.getContractAdditionArticle = function (params) {
    return axios({
        url: `/coachsg/v1/getContractAdditionArticle`,
        method: 'get',
        params
    })
};

/**
 * 获取门店信息下拉
 */
api.coachContract.getListStoreByEmpId = function (params) {
    return axios({
        url: `/coachsg/outer/marketStore/v1/getListStoreByEmpId`,
        method: 'get',
        params
    })
};

/**
 * 作废订单-深港驾校
 */
api.coachContract.cancelOrderForCoachClient = function (data) {
    return axios({
        url: `/zjerp/outer/coachClient/preEntryOrder/v1/cancelOrderForCoachClient`,
        method: 'post',
        data
    })
};

/**
 * 作废订单-其他驾校
 */
api.coachContract.stuOrderDeleteByCoachApp = function (data) {
    return axios({
        url: `/coach/OrderContract/stuOrderDeleteByCoachApp`,
        method: 'post',
        data
    })
};

/**
 * 生成合同
 * @param {Object} data
 */
 api.coachContract.generateContract = function (data) {
    return axios({
        method: 'post',
        url: '/zjerp/outer/coachClient/preEntryOrder/v1/createContractForApp',
        data
    })
}

/**
 * 生成合同-其他驾校
 * @param {Object} data
 */
 api.coachContract.createContractForApp = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/createContractForApp',
        data
    })
}

/**
 * 作废订单-作废合同
 */
api.coachContract.contractToVoid = function (data) {
    return axios({
        url: `/coach/OrderContract/contractToVoid`,
        method: 'post',
        data
    })
};

/**
 * 获取其他驾校的码表
 * @param {Object} data
 */
 api.coachContract.getOtherSchoolCode = function () {
    return axios({
        method: 'get',
        url: '/coach/OrderContract/getStudentCodeList',
    })
}

/**
 * 获取其他驾校的pos机
 * @param {Object} data
 */
 api.coachContract.getOtherSchoolPosItems = function (params) {
    return axios({
        method: 'get',
        url: '/coach/OrderContract/getPosNum',
        params
    })
}

/**
 * 获取教练带教门店和班别
 * @param {Object} data
 */
api.coachContract.getCoachBurdenDepts = function (data) {
    return axios({
        method: 'post',
        url: '/coach/OrderContract/getCoachBurdenDeptsByMobileByCoachApp',
        data
    })
}

/**
 * 获取公众号用户信息【电子合同】
 * @param {Object} params
 * @param {string} params.type 获取方式1:grant code, 2:openId
 * @param {string} params.grantCode type 为1， grantCode传grantCode， type为2，grantCode传openId
 * @param {string} params.loginType 登录类型(wxpublic,微信公众号;)
 * @param {string} params.appId appId
 */
api.coachContractGzh.getUserByWeXinPublic = function (params) {
    return axios({
        method: 'get',
        url: '/user/outer/electronicContractLogin/v1/getUserByWeXinInfoForElectronic.pass',
        params
    })
}

/**
 * 获取图形验证码
 * @params
 */
api.coachContractGzh.getImageCode = function (params) {
    return axios({
        url: `/auth/outer/sysAuth/v1/imageCode.pass`,
        method: 'GET',
        params:params
    })
};

/**
 * 获取短信
 * @params
 */
api.coachContractGzh.getMessage = function (params) {
    return axios({
        url: `/user/outer/electronicContractLogin/v1/sendMessage`,
        method: 'POST',
        data:params,
    })
};

/**
 * 登陆
 * @params
 */
api.coachContractGzh.login = function (params) {
    return axios({
        url: `/user/outer/electronicContractLogin/v1/loginElectronic`,
        method: 'POST',
        data:params
    })
};
/**
 * 登出
 * @params
 */
api.coachContractGzh.logout = function (params) {
    return axios({
        url: `/user/outer/electronicContractLogin/v1/logoutEContract`,
        method: 'POST',
        data:params
    })
};

/**
 * 获取分享config
 * @params
 */
api.coachContractGzh.getJsapiConfig = function (params) {
    return axios({
        url: `/mall/outer/share/getJsapiConfig.pass`,
        method: 'POST',
        data:params
    })
};

/**
 * 校验当前手机号是否有订单
 * @params
 */
api.coachContractGzh.checkIsOrder = function (params) {
    return axios({
        url: `/zjerp/outer/electronContract/v1/existContractByPhone`,
        method: 'get',
        params:params
    })
};

/**
 * 获取订单列表
 * @params
 */
api.coachContractGzh.getOrderList = function (data) {
    return axios({
        url: `/zjerp/outer/electronContract/v1/getListSignatureContractForWxPublic`,
        method: 'post',
        data:data
    })
};

/**
 * 校验是否有待签订的合同
 * @params
 */
api.coachContractGzh.checkIngOrder = function (data) {
    return axios({
        url: `/zjerp/outer/electronContract/v1/getWaitSignatureContractForWxPublic`,
        method: 'post',
        data:data
    })
};

/**
 * 查询驾校配置
 * @params
 */
api.timePay.selectBySchoolIdConfig = function (data) {
    return axios({
        url: `/classhour/cost/outer/classhourCostSettings/v1/selectBySchoolId.pass`,
        method: 'get',
        params:data
    })
};

/**
 * app端购买计时卡
 * @params
 */
api.timeAuth.createOrder = function (data) {
    return axios({
        url: `/mall/outer/mallOrderRemoteTiming/createOrder`,
        method: 'post',
        data:data
    })
};

/**
 * 短视频-详情
 * @params
 */
api.shortVideoShare.detail = function (data) {
    return axios({
        url: `/exam/outer/shortVideo/v1/share/detail.pass`,
        method: 'get',
        params:data
    })
};

/**
 * 短视频-分享次数
 * @params
 */
api.shortVideoShare.shareVisit = function (data) {
    return axios({
        url: `/exam/outer/shortVideo/v1/shareVisit.pass`,
        method: 'get',
        params:data
    })
};

/**
 * 短视频-详情
 * @params
 */
api.shortVideoShare.hot = function (data) {
    return axios({
        url: `/exam/outer/shortVideo/v1/hot.pass`,
        method: 'get',
        params:data
    })
};

export default api;

